import ApplicationController from './application_controller';

export default class extends ApplicationController {

  static targets = ['button', 'page'];

  toggleOne(event) {
    if (event.target.type !== 'checkbox') {
      event.preventDefault();
    }
    let toggleElement = document.querySelector('#' + event.target.dataset.toggleId);
    let iconClassOn = event.target.dataset.iconClassOn || 'icon-down';
    let iconClassOff = event.target.dataset.iconClassOff || 'icon-right'

    toggleElement.classList.toggle('hidden')
    if (event.target.dataset.toggleClass) {
      toggleElement.classList.toggle(event.target.dataset.toggleClass)
    }

    let subIcon = event.target.querySelector(iconClassOff) || event.target.querySelector(iconClassOn);
    if (subIcon) {
      subIcon.classList.toggle(iconClassOn)
      subIcon.classList.toggle(iconClassOff)
    } else {
      event.target.classList.toggle(iconClassOn)
      event.target.classList.toggle(iconClassOff)
    }

  }

  toggleList(event) {
    var toggleElements = document.querySelectorAll('#' + event.target.dataset.toggleId);
    toggleElements.forEach((toggleElement) => {
      toggleElement.classList.toggle('hidden')
      if (event.target.dataset.toggleClass) {
        toggleElement.classList.toggle(event.target.dataset.toggleClass)
      }
    });
  }
  
  toggleMetricAssignment(event) {
    const checkbox = event.target;
    const container = checkbox.closest('.metric-item');

    if (!container) return;

    const destroyField = container.querySelector('.destroy-field');
    const inputs = container.querySelectorAll('input:not(.metric-checkbox):not(.destroy-field), select, textarea');
    const isChecked = checkbox.checked;

    // Invert logic for _destroy field: checked = keep (0), unchecked = destroy (1)
    if (destroyField) {
      destroyField.value = isChecked ? '0' : '1';
    }

    // Toggle disabled state on inputs
    inputs.forEach(input => {
      input.disabled = !isChecked;
    });

    // Toggle visual state
    const detailsSection = container.querySelector('.metric-details');
    if (detailsSection) {
      if (isChecked) {
        container.classList.add('assigned');
        detailsSection.classList.remove('disabled');
      } else {
        container.classList.remove('assigned');
        detailsSection.classList.add('disabled');
      }
    }
  }

  toggleInputs(event) {
    const checkbox = event.target;
    const container = checkbox.closest('.metric-item');

    if (!container) return;

    const inputs = container.querySelectorAll('input:not(.metric-checkbox), select, textarea');
    const isChecked = checkbox.checked;

    // Toggle disabled state on inputs
    inputs.forEach(input => {
      input.disabled = !isChecked;
    });

    // Toggle visual state on container
    const detailsSection = container.querySelector('.metric-details');
    if (detailsSection) {
      if (isChecked) {
        container.classList.add('assigned');
        detailsSection.classList.remove('disabled');
      } else {
        container.classList.remove('assigned');
        detailsSection.classList.add('disabled');
      }
    }
  }
}
